<template>
  <path
    d="M19 3.00018H4.99C3.88 3.00018 3.01 3.89018 3.01 5.00018L3 19.0002C3 20.1002 3.88 21.0002 4.99 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.89018 20.1 3.00018 19 3.00018ZM19 15.0002H15.87C15.4 15.0002 15.02 15.3402 14.89 15.8002C14.54 17.0702 13.37 18.0002 12 18.0002C10.63 18.0002 9.46 17.0702 9.11 15.8002C8.98 15.3402 8.6 15.0002 8.13 15.0002H5V6.00018C5 5.45018 5.45 5.00018 6 5.00018H18C18.55 5.00018 19 5.45018 19 6.00018V15.0002Z"
  />
</template>
